import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { UserDashboardView, UserDocumentsView } from '@blockpulse3/web-client/dashboard';
import { SubscriptionView } from '@blockpulse3/web-client/subscription';

import { AppLayout } from '../layouts';

type Props = unknown;

/**
 * UserWorkspaceRoutes.
 * Renders all user related routes, set workspace to null.
 * userIdentity will be used instead.
 *
 * @returns {JSX.Element}
 */
export function UserWorkspaceRoutes(): JSX.Element {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<UserDashboardView />} />
        <Route element={<UserDocumentsView />} path={routes.me.documents.href} />
        <Route element={<SubscriptionView />} path={routes.me.subscription.href} />
        <Route element={<Navigate replace to={routes.me.href} />} path="*" />
      </Route>
    </Routes>
  );
}

export type UserWorkspaceRoutesProps = Props;
